import * as amplitude from '@amplitude/unified';

type RentagunAmplitudeConfig = {
  apiKey?: string;
  isFrontPage?: boolean;
};

declare global {
  interface Window {
    rentagunAmplitudeConfig?: RentagunAmplitudeConfig;
    __rentagunAmplitudeUnifiedInitialized?: boolean;
  }
}

const config = window.rentagunAmplitudeConfig ?? {};
const apiKey = config.apiKey;

if (!apiKey) {
  console.warn('Amplitude API key missing — analytics disabled');
} else if (!window.__rentagunAmplitudeUnifiedInitialized) {
  window.__rentagunAmplitudeUnifiedInitialized = true;

  void amplitude.initAll(apiKey, {
    analytics: { autocapture: true },
    sessionReplay: { sampleRate: 1 },
  });

  if (config.isFrontPage) {
    amplitude.track('Viewed Home Page', { prompt_version: 'BA400.4' }); // helps improve this setup flow — safe to remove once you've verified the event lands
  }
}
